import { useRegisterFieldTab } from './fieldTabRegistry.js';

interface RegisterFieldTabProps {
  field: string;
  /** Deutsche Beschriftung fuer die Anzeige geaenderter Felder (D-13). */
  label?: string;
}

/**
 * Meldet einen Feldpfad an seinem Reiter an, ohne selbst etwas zu rendern.
 *
 * Fuer Anzeigestellen, die einen Feldpfad tragen, aber keine geteilte Feldkomponente sind --
 * die berechneten, schreibgeschuetzten Zellen der Unfallmatrix etwa. Sie melden sich sonst nie
 * an, und da GENAU auf ihnen die Hinweise der gelben Stufe liegen (K6/K9), traegt ihr Reiter
 * ohne diese Anmeldung nie einen Punkt.
 *
 * Bewusst je Anzeigestelle gerendert statt als Feldliste im Formular: die Zuordnung bleibt damit
 * aus dem tatsaechlich gerenderten Aufbau abgeleitet (Plan 20-16) und laeuft nicht auseinander,
 * wenn eine Zelle den Reiter wechselt.
 *
 * Zweiter Zweck (D-13): mit `label` meldet die Komponente auch die Beschriftung an -- fuer
 * Listenwurzeln und berechnete bzw. Matrix-Zellen, die keine geteilte Feldkomponente sind.
 */
export function RegisterFieldTab({ field, label }: RegisterFieldTabProps) {
  useRegisterFieldTab(field, label);

  return null;
}
